import graphql from './graphql';

const query = /* GraphQL */ `
  query EvaluationQuestion_list($lessonId: ID) {
    EvaluationQuestion_list(lessonId: $lessonId) {
      id
      question
      order
      value
      evaluationQuestionTypeId
    }
  }
`;

const EvaluationQuestionList = async ({ lessonId }) =>
  graphql(query, { lessonId }).then(
    // eslint-disable-next-line camelcase
    ({ EvaluationQuestion_list }) => EvaluationQuestion_list
  );

export default EvaluationQuestionList;
